import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function usePaymentAPI() {
  const { userRef, menuIdRef, languageRef } = useStorage();

  function loadPaymentFromRemote(id) {
    const url = `/vbeta2/payments/${id}`;

    return axios({
      url,
      method: 'get',
      params: {
        show_orders: true,
      },
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Accept-Language': languageRef.current?.tag,
        'Menu-Id': menuIdRef.current,
      },
      responseType: 'json',
    });
  }

  function calculateRemainingFeeFromRemote(data) {
    const url = `/vbeta2/menu/payments/calc_remaining_fee`;

    return axios({
      url,
      method: 'post',
      data,
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Accept-Language': languageRef.current?.tag,
        'Menu-Id': menuIdRef.current,
      },
      responseType: 'json',
    });
  }

  return {
    loadPaymentFromRemote,
    calculateRemainingFeeFromRemote,
  };
}

export { usePaymentAPI };
